// Minimal reactive app state. Cesium owns the render loop; the store holds UI state
// (connection status, active project, selected item) that panels subscribe to.
import { atom } from "nanostores";

import type { ClientInfo } from "./api";
import type { MgaZone } from "./cesium/mga";

export const $connected = atom<boolean | null>(null);
export const $backendVersion = atom<string>("");
export const $activeProjectId = atom<number | null>(null);
export const $selectedItemId = atom<number | null>(null);
export const $selectedItemName = atom<string | null>(null);
// Logged-in username, stamped onto sign-offs and comments so the audit trail shows who.
export const $user = atom<string>("");
// Viewport staff: see every client, manage clients/users/backups. Drives admin-panel gating.
export const $isSuperuser = atom<boolean>(false);
// The logged-in user's own client (null for a superuser, who spans all clients).
export const $client = atom<ClientInfo | null>(null);
// Grid zone for the cursor coordinate readout. Chosen by the user, not inferred from
// longitude: a project works in one zone and its coordinates must stay in it even when the
// cursor strays over a zone boundary. Persisted per project by ui/viewTools.ts.
export const $mgaZone = atom<MgaZone>(50);
// Representative longitude of the active project's data, set once its assets load. Used only
// to pick the DEFAULT grid zone for a project that has no saved choice yet, so SOE Kangwinan
// starts on zone 54 and the Pilbara projects on 50 without anyone configuring it.
export const $projectLon = atom<number | null>(null);
